import request from '@/utils/request'
//迁移列表
export function oldOrgList(data) {
  return request({
    url: '/api/v2/move/oldOrgList',
    method: 'post',
    data
  })
}

//迁移
export function moveOrg(data) {
  return request({
    url: '/api/v2/move/moveOrg',
    method: 'post',
    data
  })
}
//采集
export function companyMove(data) {
  return request({
    url: '/api/v2/move/companyMove',
    method: 'post',
    data
  })
}